import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change, Field } from 'redux-form';

import actions from 'actions';
import Radio from 'components/Input/Radio/index';
import {
    ESTIMA_FORM,
    FORM_ADDRESS_NAME,
    FORM_CITY_NAME,
    FORM_ZIP,
    KEEP_USER_ADDRESS_CHOICE,
} from 'constants/Global';
import { translate } from 'helpers/Translate';

/**
 * Address suggestion.
 */
export default class AddressSuggest extends Component {
    /**
     * React lifecycle.
     * Update value displayed if real value has changed.
     * @param {Object} prevProps Prev props of component
     */
    componentDidUpdate(prevProps) {
        const { address, dispatch, values } = this.props;

        if (
            values._suggested_address !== null &&
            values._suggested_address !== prevProps.values._suggested_address
        ) {
            let updatedAddress;

            if (values._suggested_address === KEEP_USER_ADDRESS_CHOICE) {
                updatedAddress = address.selectedAddress;
            } else {
                updatedAddress = address.suggestedAddresses[values._suggested_address];
            }

            dispatch(actions.updateAddressMapCoordinates(updatedAddress.coordinates));
            dispatch(change(ESTIMA_FORM, 'coordinates', updatedAddress.coordinates));
            dispatch(change(ESTIMA_FORM, FORM_ADDRESS_NAME, updatedAddress.addressName));
            dispatch(change(ESTIMA_FORM, FORM_CITY_NAME, updatedAddress.cityName));
            dispatch(change(ESTIMA_FORM, FORM_ZIP, updatedAddress.zip));

            dispatch(change(ESTIMA_FORM, '_suggested_address', values._suggested_address));
            dispatch(actions.validStep(null, true));
        }
    }

    /**
     * React lifecycle.
     */
    render() {
        const { address } = this.props;
        const userFullAddress = (
            <span>
                {translate("Non, l'adresse est bien le")}{' '}
                <span className="text--primary text--bold">
                    {address.selectedAddress.addressName}, {address.selectedAddress.zip}{' '}
                    {address.selectedAddress.cityName}
                </span>
            </span>
        );

        return (
            <div className="radio-list" data-step-address-suggest>
                {address.suggestedAddresses.map((suggestedAddress, index) => {
                    const fullAddress = (
                        <span>
                            {translate('Vouliez-vous dire le')}{' '}
                            <span className="text--primary text--bold">
                                {suggestedAddress.addressName}, {suggestedAddress.zip}{' '}
                                {suggestedAddress.cityName}
                            </span>{' '}
                            ?
                        </span>
                    );
                    return (
                        <div
                            className="radio-list__item"
                            key={`address${suggestedAddress}`}
                            data-step-address-suggestion={index}
                        >
                            <Field
                                component={Radio}
                                label={fullAddress}
                                id={`address${index}`}
                                radioValue={String(index)}
                                name="_suggested_address"
                            />
                        </div>
                    );
                })}
                <div className="radio-list__item" data-step-address-suggestion="keep">
                    <Field
                        component={Radio}
                        label={userFullAddress}
                        id={KEEP_USER_ADDRESS_CHOICE}
                        name="_suggested_address"
                    />
                </div>
            </div>
        );
    }
}

AddressSuggest.propTypes = {
    address: PropTypes.shape({}),
    dispatch: PropTypes.func,
    values: PropTypes.shape({}),
};
